import { jsxs, jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { Skeleton } from "@nxt-costco-com/forge-components";
import { SpaceMd } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../../Util/CostcoBox.js";
const COMPONENT_NAME = "ProductTileSkeleton";
const ProductTileSkeleton = ({
  isHorizontal,
  minProductTileImageWidth
}) => {
  if (isHorizontal) {
    return /* @__PURE__ */ jsxs(
      CostcoBox,
      {
        sx: {
          alignItems: "flex-end",
          display: "flex",
          justifyContent: "center",
          minWidth: "100%"
        },
        children: [
          /* @__PURE__ */ jsx(
            CostcoBox,
            {
              sx: {
                marginRight: SpaceMd,
                minWidth: minProductTileImageWidth,
                width: "200px"
              },
              children: /* @__PURE__ */ jsx(Skeleton, { height: 200, variant: "rectangular" })
            }
          ),
          /* @__PURE__ */ jsxs(Stack, { spacing: 1, sx: { minWidth: "60%" }, children: [
            /* @__PURE__ */ jsx(CostcoBox, { sx: { width: "40%" }, children: /* @__PURE__ */ jsx(Skeleton, { variant: "textBody" }) }),
            /* @__PURE__ */ jsx(Skeleton, { variant: "textBody" }),
            /* @__PURE__ */ jsx(Skeleton, { variant: "textBody" }),
            /* @__PURE__ */ jsx(Skeleton, { height: 40, variant: "rectangular" })
          ] })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs(Stack, { "data-testid": "productTileSkeletonTestId", spacing: 4, width: 160, children: [
    /* @__PURE__ */ jsx(Skeleton, { height: 160, variant: "rectangular" }),
    /* @__PURE__ */ jsxs(Stack, { spacing: 1, children: [
      /* @__PURE__ */ jsx(Skeleton, { variant: "textBody", width: 52 }),
      /* @__PURE__ */ jsx(Skeleton, { variant: "textBody" }),
      /* @__PURE__ */ jsx(Skeleton, { variant: "textBody", width: 104 })
    ] }),
    /* @__PURE__ */ jsx(Skeleton, { height: 40, variant: "rectangular" })
  ] });
};
ProductTileSkeleton.displayName = COMPONENT_NAME;
export {
  ProductTileSkeleton
};
